import type { ReactNode } from 'react';

/** Big, readable-from-2-metres countdown ring for the hands-free start. */
export function ArmedIndicator({
  progress,
  secondsLeft,
  allPassed,
  failing,
  holdLabel = 'Hold still — starting',
}: {
  progress: number;
  secondsLeft: number | null;
  allPassed: boolean;
  failing: string[];
  holdLabel?: string;
}): ReactNode {
  const color = allPassed ? 'var(--color-state-good)' : 'var(--color-state-fhp)';
  return (
    <div className="flex flex-col items-center gap-2">
      <div
        className="grid size-28 place-items-center rounded-full shadow-xl"
        style={{
          background: `conic-gradient(${color} ${Math.round(progress * 100)}%, rgba(255,255,255,0.25) ${Math.round(progress * 100)}% 100%)`,
        }}
        role="status"
        aria-live="polite"
        aria-label={
          allPassed
            ? `Starting in ${secondsLeft ?? 0} seconds`
            : `Waiting: ${failing.join(', ')}`
        }
      >
        <div className="grid size-24 place-items-center rounded-full bg-ink/85 text-white">
          {allPassed ? (
            <span className="text-3xl font-bold tabular-nums">{secondsLeft ?? 0}</span>
          ) : (
            <span className="px-2 text-center text-[11px] font-semibold leading-tight">
              {failing[0] ?? 'Waiting'}
            </span>
          )}
        </div>
      </div>
      <p className="rounded-full bg-ink/75 px-3 py-1 text-xs font-medium text-white">
        {allPassed ? holdLabel : 'Waiting for a usable shot'}
      </p>
    </div>
  );
}
